import React from 'react'
import { Box, Divider, Typography } from '@mui/material'
import { FamilyRestroom } from '@mui/icons-material'
import { useNavigate } from 'react-router'
import { CashAmount } from '../../../swagger'
import getLocaleCurrencyForAmount from '../../../utils/getLocaleCurrencyForAmount'
import FinancialAmount from './common/FinancialAmount'
import FinancialLabel from './common/FinancialLabel'
import { useTranslation } from 'react-i18next'

interface FamilyRowProps {
  family: {
    name: string
    amount: CashAmount
    userKey?: number
    familyOwesDirector: CashAmount
  }
  index: number
}

const FamilyRow: React.FC<FamilyRowProps> = ({ family, index }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Box
      onClick={() =>
        family.userKey !== undefined &&
        navigate({ pathname: `/family-profile/${family.userKey}` })
      }
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: index % 2 === 0 ? 'white' : '#f8f9ff',
        p: 1.5,
        marginLeft: 2,
        borderLeft: (theme) => `3px solid ${theme.palette.program.challenge}`,
        cursor: 'pointer',
        '&:hover': { backgroundColor: (theme) => theme.palette.hover.main },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FamilyRestroom
          sx={{
            mr: 2,
            color: (theme) => theme.palette.program.challenge,
            fontSize: 16,
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: (theme) => theme.palette.primary.main,
            fontWeight: 600,
            fontFamily: 'sweet-sans-pro, sans-serif',
            fontSize: '0.875rem',
          }}
        >
          {family.name}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          pr: 2,
          ml: 'auto',
        }}
      >
        <Box sx={{ textAlign: 'right' }}>
          <FinancialLabel sx={{ fontSize: '0.625rem' }}>
            {t('FamilyRow.FamilyOwesTutor.Label', 'Family Owes Tutor')}
          </FinancialLabel>
          <FinancialAmount amountType="positive">
            {getLocaleCurrencyForAmount(
              family.amount.amount,
              family.amount.currencyCode
            )}
          </FinancialAmount>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ opacity: 0.3 }} />
        <Box sx={{ textAlign: 'right' }}>
          <FinancialLabel sx={{ fontSize: '0.625rem' }}>
            {t('FamilyRow.FamilyOwesDirector.Label', 'Family Owes Director')}
          </FinancialLabel>
          <FinancialAmount amountType="positive">
            {getLocaleCurrencyForAmount(
              family.familyOwesDirector.amount,
              family.familyOwesDirector.currencyCode
            )}
          </FinancialAmount>
        </Box>
      </Box>
    </Box>
  )
}

export default FamilyRow
